import { CircleRsvpFragment } from '@modernhealth/circles-graphql/v2';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { CircleSessionCard } from './CircleSessionCard';

export const CircleRsvpCard: React.FC<{
    rsvp: CircleRsvpFragment;
    isPrevious?: boolean;
    id: string;
}> = ({ rsvp, isPrevious, id }) => {
    const { t } = useTranslation('circles');

    return (
        <CircleSessionCard
            id={id}
            series={rsvp.session.topic.series}
            topic={rsvp.session.topic}
            session={rsvp.session}
            showAccess={false}
        >
            {!isPrevious ? t(['cards.rsvp.cta', ''], { fallbackLng: [] }) : null}
        </CircleSessionCard>
    );
};
